import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed } from "shared/lib/styles";

import LogoOnLight from "scmp-app/components/plus/plus-logo/logo-on-light.svg";

import Separator from "./separator.svg";

export const Content = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;

  margin-block: 0 !important;
`;

export const Header = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const StyledLogo = styled(LogoOnLight)`
  inline-size: auto;
  block-size: 19px;
`;

export const StyledSeparator = styled(Separator)`
  color: #000000;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRoboto};
`;

export const Title = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  padding: 20px;

  border-radius: 8px;

  background: #ffffff;

  outline: 1px solid #cccccc;
`;
